/**
 * Brand — Corporate-Schriftzug „stilltouched" / „stilltouchedX"
 *
 * iter163 · CI-konform:
 *   - alles klein geschrieben
 *   - Schriftart: Manrope (globaler `sans` in Tailwind)
 *   - „still"     → SemiBold, #FFFFFF   (auf dunklen Backgrounds)
 *   - „touched"/„touchedX" → Regular, #C0C0C0
 *
 * Props:
 *  - suffix         Optional angehängter Text (z. B. "X" für „stilltouchedX")
 *  - className      optionale Tailwind-Klassen für den Wrapper
 *  - stillClass     Overrides für den „still"-Teil (nur Farbe/Weight-Overrides)
 *  - touchedClass   Overrides für den „touched"-Teil
 *  - variant        "on-dark" (default, weiß+silber) | "on-light" (black+silver)
 */
export default function Brand({
  suffix = "",
  className = "",
  stillClass,
  touchedClass,
  variant = "on-dark",
}) {
  const defaultStill  = variant === "on-light"
    ? "font-semibold text-brand-black"
    : "font-semibold text-brand-white";
  const defaultTouch  = "font-normal text-brand-silver";
  return (
    <span className={`inline-flex items-baseline lowercase tracking-tight ${className}`}>
      <span className={stillClass || defaultStill}>still</span>
      <span className={touchedClass || defaultTouch}>touched<span className="normal-case">{suffix}</span></span>
    </span>
  );
}
